import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import { getUA } from 'react-device-detect'
import classNames from 'classnames'
import commandList from './commandList'

import './shortcut.scss'

const getShortcutObject = commandKey => {
	const command = commandList.find(obj => obj.key === commandKey)
	const commandOS =
		getUA.indexOf('Mac OS X') !== -1 ? command.mac : command.win

	return commandOS
}

const getShortcutString = commandKey =>
	getShortcutObject(commandKey)
		.join('+')
		.toLowerCase()

class ShortcutComponent extends PureComponent {
	render() {
		const { t, commandKey, label, inline } = this.props

		const command = getShortcutObject(commandKey)

		const shortCutClass = 'c-shortcut'
		const cssClasses = classNames(
			shortCutClass,
			inline && `${shortCutClass}--inline`
		)

		return (
			<div className={cssClasses}>
				{label && (
					<div className="c-shortcut__label">
						{t(`commands.${commandKey}`)}
					</div>
				)}
				<div className="c-shortcut__keys">
					{command.map(key => (
						<div className="c-shortcut__key" key={key}>
							{key === 'command'
								? '⌘'
								: key === 'shift'
								? '⇧'
								: key === 'tab'
								? '⇥'
								: key === 'option'
								? '⌥'
								: key === 'up'
								? '↑'
								: key === 'down'
								? '↓'
								: key}
						</div>
					))}
				</div>
			</div>
		)
	}
}

ShortcutComponent.propTypes = {
	commandKey: PropTypes.string,
	label: PropTypes.bool,
	inline: PropTypes.bool,
}

ShortcutComponent.defaultProps = {
	commandKey: null,
	label: false,
	inline: false,
}

const Shortcut = translate()(ShortcutComponent)

export { Shortcut, getShortcutString }
